<div class="modal-loja-lado" [ngClass]="{'colapsado': colapsado}">
  <div class="header">
    <h4>
      <i class="fe-server ml-1"> </i> Servidor Impressão -
      <span  class="badge badge-blue">{{servidorExecutor.obtenhaNome()}}</span>

      <i class="fa fa-edit ml-1 fa-lg cpointer" (click)="abraModalServidorImpressao()"></i>
    </h4>

    <div class="servidor-status"  >
        <span class="badge badge-success" *ngIf="servidorExecutor.conectado()">

          Conectado
        </span>

        <span class="badge badge-danger" *ngIf="!servidorExecutor.conectado()">
          Desconectado
        </span>
    </div>
    <!-- Status quando não é servidor -->
    <div class="servidor-status" *ngIf="false">
        <span class="badge badge-muted">
          <i class="fe-monitor"></i>
          Cliente
        </span>
    </div>

      <button class="btn btn-link btn-toggle-colapso" (click)="alternarColapso()" [attr.aria-label]="colapsado ? 'Expandir' : 'Contrair'">
        <i class="fas" [ngClass]="{'fa-angle-double-left': colapsado, 'fa-angle-double-right': !colapsado}"></i>
      </button>

      <button class="btn btn-link btn-fechar" (click)="fechar()">
        <i class="fas fa-times" style="    font-size: 20px;"></i>
      </button>
  </div>

  <div class="content">
     <ng-container *ngIf="servidorExecutor.servidorRegistrado">
       <app-gerenciador-jobs-impressao></app-gerenciador-jobs-impressao>
     </ng-container>

     <div class="alert alert-danger" *ngIf="!servidorExecutor.servidorRegistrado">
          Nenhum servidor impressão configurado
     </div>
  </div>

</div>


<ng-container  *ngIf="modalServidorAberto">
  <app-modal-servidor-impressao   #modalServidorImpressao
                                  [empresa]="empresa"  [servidorSelecionado]="servidorSelecionado"  [editandoServidor]="true"
                                  (salvou)="salvouServidor($event)" (fechouModal)="fechouModalServidor($event)">

  </app-modal-servidor-impressao>
</ng-container>

